<template>
  <div>
    <!--banner轮播-->
    <div class="swiper-container" id="mySwiper">
      <div class="swiper-wrapper">
        <div class="swiper-slide" v-for="(banner, index) in bannerList" :key="index" >
          <img :src="banner.img"  mode="aspectFill"  style="width: 100%;"/>
        </div>
      </div>
      <!-- 如果需要分页器 -->
      <div class="swiper-pagination"></div>

      <!-- 如果需要导航按钮 -->
      <div class="swiper-button-prev"></div>
      <div class="swiper-button-next"></div>
    </div>

    <!-- Feature Area Starts -->
    <section class="feature-area section-padding2" style="padding-top: 40px">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <div class="section-top text-center">
              <h2>MENU</h2>
              <p>
                <img src="../../static/assets/images/013.jpg" mode="aspectFill"  style="width: 100%;"/>
                <img src="../../static/assets/images/014.jpg" mode="aspectFill"  style="width: 100%;" />
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>


<!--    <section class="feature-area section-padding2" style="background-color: #000;padding-top: 40px">-->
<!--      <div class="container">-->
<!--        <div class="row">-->
<!--          <div class="col-lg-12">-->
<!--            <div class="section-top text-center">-->
<!--              <p style="color:#fff;">UPDATED WEEKLY</p>-->
<!--              <h2 style="color:#fff;">Rotating Tap List</h2>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--        <div class="row">-->
<!--          <div class="col-lg-12">-->
<!--            <div class="section-top text-center">-->
<!--              <el-collapse class="custom-collapse">-->
<!--                <el-collapse-item title="★ Cracking Lager - 4%" name="1">-->
<!--                  <div>Our super bright, American style light lager. Brewed with premium NZ Gladfield malts, this cracking lager is designed to quench your thirst while knocking off a hard day's work.</div>-->
<!--                </el-collapse-item>-->
<!--                <el-collapse-item title="★ Oishii Rice Lager - 4.5%" name="2">-->
<!--                  <div>Crisp, dry and refreshing. Pouring exceptionally light in colour thanks to the large amount of flaked rice included in the mash.</div>-->
<!--                </el-collapse-item>-->
<!--                <el-collapse-item title="★ Mosaic Pale Ale - 5.1%" name="3">-->
<!--                  <div>Brewed to showcase the Mosaic hop, it's a well balanced, classic American pale ale. Earthy, punchy, and full of flavour.</div>-->
<!--                </el-collapse-item>-->
<!--                <el-collapse-item title="★ Citrus Pacific Ale - 4.8%" name="4">-->
<!--                  <div>This citrusy number features Amarillo and Galaxy hops plus a big dose of orange zest - aromas of mandarin, wheat and candied orange. it’s all citrus fruits, with a pithy grapefruit bitterness and finishing like freshly squeezed orange juice.</div>-->
<!--                </el-collapse-item>-->
<!--                <el-collapse-item title="★ El Toro IPA - 6.7%" name="5">-->
<!--                  <div>We took the best west coast IPAs we’ve had over the years and created El Toro. Perfectly balanced bitterness from Azacca, Cascade and Citra hops, supported by a robust torso and a crisp, clean finish make this bull bold.</div>-->
<!--                </el-collapse-item>-->
<!--                <el-collapse-item title="★ Oak-Aged Helles Lager- 5.4%" name="6">-->
<!--                  <div>"Neighbourwood Beers" - a collab with our neighbours, Molly Rose. A traditional Helles Lager aged on French oak staves for 3 months. Layers of vanilla, exotic spices and coffee beans, finishing with a snappy tannin like bitterness normally found in an oaky Pinot Noir.</div>-->
<!--                </el-collapse-item>-->
<!--                <el-collapse-item title="★ Pink Motel Rosé Sour - 4.1%" name="7">-->
<!--                  <div>An exquisite fruited sour, brewed with Sweet Cherry, Red Raspberries, Tahitian Lime, and Blackcurrant. An eclectic mix of Rosé flavours on a salty sour base, laying down some seriously funky refreshment.</div>-->
<!--                </el-collapse-item>-->
<!--                <el-collapse-item title="★ Serenity Passionfruit Seltzer - 5%" name="8">-->
<!--                  <div>It's brewed with real fruit. No nasty flavours or extracts will be found in this seltzer. Let your taste buds do the talking. Contains Gluten.</div>-->
<!--                </el-collapse-item>-->
<!--                <el-collapse-item title="★ The Misfit Amber Ale - 4.8%" name="9">-->
<!--                  <div>The Mill x Co-Conspirators The Misfit: Amber Ale</div>-->
<!--                </el-collapse-item>-->
<!--                <el-collapse-item title="★ In Bloom IPA - 5.9%" name="10">-->
<!--                  <div>A 5.9% change of seasons IPA, bright and juicy. Hopped with Citra and Galaxy. Delicious and fresh. Tropical fruit meets stonefruit in a glass.</div>-->
<!--                </el-collapse-item>-->
<!--                <el-collapse-item title="★ Cannonball: Oak Aged Scotch Ale - 8.2%" name="11">-->
<!--                  <div>Pouring a deep mahogany brown with a tight beige head this beer does not keep its malt-first flavour profile a secret. The aroma contains notes of burnt caramel, earl grey tea, fresh coffee and a mild woody smokiness. </div>-->
<!--                </el-collapse-item>-->
<!--              </el-collapse>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--        <div class="row">-->
<!--          <div class="col-lg-12">-->
<!--            <div class="section-top text-center">-->
<!--              <p style="color:#fff;font-style: normal;font-size: 19px">While beer is at the heart of what we do, our carefully curated wine list, spirits and cocktail menu offer delicious options for those looking to explore beyond the beer glass.</p>-->
<!--              <button type="submit" class="template-btn" @click="submit">Full Menu</button>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </section>-->
    <el-dialog
      :visible.sync="showPdf"
      title=""
      width="800px"
      append-to-body
    >
      <pdf
           :src="pdfSrc"
      ></pdf>
    </el-dialog>

  </div>
</template>

<script>
  import Swiper from 'swiper'
  import pdf from 'vue-pdf'
  export default {
    mounted () {
      // 跳转后返回页面顶部
      window.scrollTo(0, 0)
    },
    components: {pdf},

    props: {},

    data () {
      return {
        showPdf: false,
        pdfSrc: '../../static/assets/images/1.pdf',
        bannerList: [
          {
            img: '../../static/assets/images/021.jpg'
          },
          {
            img: '../../static/assets/images/016.jpg'
          },
          {
            img: '../../static/assets/images/017.jpg'
          },
          {
            img: '../../static/assets/images/018.jpg'
          },
          {
            img: '../../static/assets/images/019.jpg'
          },
          {
            img: '../../static/assets/images/020.jpg'
          },
          {
            img: '../../static/assets/images/015.jpg'
          }
        ]
      }
    },
    methods: {
      submit: function (event) {
        this.showPdf = true
      }
    },
    watch: {
      banner: {
        handler (newBanner, oldBanner) {
          // 只能监听到轮播图数据已经有了，但是v-for动态渲染结构我们还是没有办法确定的，因此还是需要用nextTick
          // nextTick:  在下次 DOM 更新循环结束之后执行延迟回调。在修改数据之后立即使用这个方法，获取更新后的 DOM
          this.$nextTick(() => {
            // eslint-disable-next-line no-undef,no-unused-vars
            const mySwiper = new Swiper('.swiper-container', {
              loop: true, // 循环模式选项
              // 如果需要分页器
              pagination: {
                el: '.swiper-pagination',
                // 点击小球的时候也切换图片
                clickable: true
              },
              // 如果需要前进后退按钮
              navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev'
              },
              // 如果需要滚动条
              scrollbar: {
                el: '.swiper-scrollbar'
              }
            })
          })
        },
        // 立即监听：不管你数据有没有变化，我上来立即监听一次
        immediate: true
      }
    }
  }
</script>

<style>
.el-step.is-center .el-step__description{
  margin-top: 40px;
  font-size: 14px;
  color: rgba(0, 0, 0, 1);
}
.el-step__icon.is-icon{
  background: aliceblue;
}
.el-collapse{
  border-top: 1px solid #4b4949 !important;
  border-bottom: 1px solid #4b4949 !important;;
}
.el-collapse .el-collapse-item__header {
  background-color: #000;
  padding: 30px 0;
  color: #fff;
  font-size: 17px;
  font-weight: bold;
  border-bottom-color: #4b4949;
}
.el-collapse .el-collapse-item__wrap{
  background-color: #000;
  border-bottom: 1px solid #4b4949;
}
.el-collapse .el-collapse-item__content{
  font-size: 17px;
  color: #cbc9c9;
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// BlogDetails.vue?516ed6ee